import styled from 'styled-components';
import { ASSETS } from '../../../../../assets';

export const MinimizeIcon = styled(ASSETS.MINIMIZE)`
  width: 32px;
  cursor: pointer;
`;
